import styled from 'styled-components';
import { FlexboxProps, LayoutProps, MarginProps, PaddingProps, flexbox, layout, margin, padding, compose } from 'styled-system';

export const Container = styled.div<FlexboxProps | LayoutProps | MarginProps | PaddingProps>(compose(flexbox, layout, margin, padding));

Container.defaultProps = {
  display: 'flex',
  maxWidth: '1152px',
  width: '100%',
  margin: 'auto',
  px: ['0px', '59px', null, null, '0px'],
};

Container.displayName = 'Container';
